import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Col, Row, Button } from 'react-bootstrap';

import { Http } from '../../../support';
import { useStore } from '../../../store';
import Loading from '../../../facturotopia/loading/Loading';
import LoadingButton from '../../../facturotopia/LoadingButton';
import PageHeader from '../../../support/page-header/PageHeader';
import AutofacturacionTicketTracking from './components/AutofacturacionTicketTracking';
import AutofacturacionTicketGeneralInfo from './components/AutofacturacionTicketGeneralInfo';
import ComprobanteDownloadActions from '../../../app/comprobantes/info/components/ComprobanteDownloadActions';

class AutofacturacionTicketInfo extends Component {
  state = {
    stamping: false,
  };

  constructor(props) {
    super(props);

    const { data = {} } = props || {};
    const { id } = this.props.match.params;

    this.state = {
      data: !!data.id ? { ...data } : { id },
    };

    props.info.reset();
    this.props.info.detail(id);
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  handleOnStampingRequest = async () => {
    const { data } = this.props;

    this.setState({
      stamping: true,
    });

    try {
      const params = {
        tickets: [data.id],
      };

      const response = await Http.post(`/api/autofacturacion/egreso`, params);

      window.ToastManager.show({
        variant: 'Success',
        title: 'Exitoso',
        message: response.data?.message || response.message || 'Nota de crédito timbrado!',
      });
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No se pudo emitir tu comprobante.',
      });
    } finally {
      this.props.info.detail(data.id);
      this.setState({
        stamping: false,
      });
    }
  };

  render() {
    const { data = {}, busy } = this.props;
    const { tracking = [] } = data;
    const { stamping } = this.state;

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    return (
      <>
        <PageHeader
          to="/modulos/autofacturacion/tickets"
          text="Tickets"
        />

        <Row>
          <Col className="text-right">
            {[0, -2, -3, 'pending', 'failed', 'error'].indexOf(data.status) > -1 && (
              <div className="mr-2">
                <Button
                  as={Link}
                  variant="secondary"
                  to={{
                    pathname: `/modulos/autofacturacion/tickets/${data.id}/facturar`,
                  }}
                  className="text-muted mr-2"
                >
                  Facturar
                </Button>
              </div>
            )}

            <div className="d-inline-flex ">
              {[-3, 'failed'].indexOf(data.proxy_status) > -1 && (
                <div className="mr-2">
                  <LoadingButton
                    loading={stamping}
                    disabled={stamping}
                    onClick={this.handleOnStampingRequest}
                  >
                    {stamping ? 'Procesando...' : 'Nota de crédito'}
                  </LoadingButton>
                </div>
              )}

              {!!data.cfdi_uuid && [1, 'success', -1, 'cancelled', 9, 'individual'].indexOf(data.status) > -1 && (
                <div>
                  <ComprobanteDownloadActions data={{ uuid: data.cfdi_uuid }} />
                </div>
              )}
            </div>
          </Col>
        </Row>

        <AutofacturacionTicketGeneralInfo data={data} />

        {tracking.length > 0 && (
          <div className="py-3">
            <div className="mb-3">
              <strong>SEGUIMIENTO DEL TICKET</strong>
            </div>
            <AutofacturacionTicketTracking data={data} />
          </div>
        )}
      </>
    );
  }
}

const mapActions = (actions) => {
  return {
    info: actions.modulo.autofacturacion.info,
  };
};

const mapState = (store) => {
  return store.modulo.autofacturacion.info;
};

export default connect(useStore, mapState, mapActions)(AutofacturacionTicketInfo);
